import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LANGUAGE } from 'src/constants';

import { en } from './locales/en';
import { ja } from './locales/ja';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: LANGUAGE.EN,
    debug: false,
    lng: LANGUAGE.JA,
    resources: {
      en: {
        translation: en,
      },
      ja: {
        translation: ja,
      },
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
  .catch(error => {
    throw error;
  });

const I18n = i18n;
// const t = (...args: Parameters<TFunction>) => I18n.t(...args);

export { I18n };
